export const Attiva = 0
export const NonAttiva = 1
export const InScadenza = 2
export const NonTrovata = 3
